//MyLabs

import React, { useContext, useState } from "react";



const MyLabs = () => {




    return (
        <>
            <div className="w-full flex p-5 text-xl font-normal"
                style={{
                    borderRadius: "8px",
                    background: "#F8F9FE",
                    boxShadow: "2px 2px 10px 0px rgba(149, 156, 225, 0.50)"
                }}
            >
                <p className="w-[50%] border-e-2">S.No</p>
                <p className="w-[100%] text-center border-e-2">Lab Name </p>
                <p className="w-[100%] text-center border-e-2">Batch</p>
                <p className="w-[100%] text-center border-e-2">No. Of Students</p>
                <p className="w-[100%] text-center">No. Of Sessions</p>


            </div>

            <div>
                <div className="w-full flex p-5 text-xl font-normal mt-10"
                    style={{
                        borderRadius: "5px",
                        border: "0.5px solid #8F8F8F",
                        background: "#FFF",
                        boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)"
                    }}
                >
                    <p className="w-[50%] border-e-2">1</p>
                    <p className="w-[100%] text-center border-e-2">Harsh Kadyan </p>
                    <p className="w-[100%] text-center border-e-2">Product Lab</p>
                    <p className="w-[100%] text-center border-e-2">Week 4</p>
                    <p className="w-[100%] text-center">12 Apr 2023</p>


                </div>

                <div className="flex justify-end">
                    <div className=" flex p-5 text-xl font-normal mt-5 w-[67%]"
                        style={{
                            borderRadius: "5px",
                            border: "0.5px solid #8F8F8F",
                            background: "#F0F7FF",
                            boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)"
                        }}
                    >

                        <p className="w-[100%] text-center border-e-2">Product Lab</p>
                        <p className="w-[100%] text-center border-e-2">Week 4</p>
                        <p className="w-[100%] text-center">12 Apr 2023</p>


                    </div>
                </div>
                <div className="flex justify-end">
                    <div className=" flex p-5 text-xl font-normal mt-5 w-[67%]"
                        style={{
                            borderRadius: "5px",
                            border: "0.5px solid #8F8F8F",
                            background: "#F0F7FF",
                            boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)"
                        }}
                    >

                        <p className="w-[100%] text-center border-e-2">Product Lab</p>
                        <p className="w-[100%] text-center border-e-2">Week 4</p>
                        <p className="w-[100%] text-center">12 Apr 2023</p>


                    </div>
                </div>
                <div className="flex justify-end">
                    <div className=" flex p-5 text-xl font-normal mt-5 w-[67%]"
                        style={{
                            borderRadius: "5px",
                            border: "0.5px solid #8F8F8F",
                            background: "#F0F7FF",
                            boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)"
                        }}
                    >

                        <p className="w-[100%] text-center border-e-2">Product Lab</p>
                        <p className="w-[100%] text-center border-e-2">Week 4</p>
                        <p className="w-[100%] text-center">12 Apr 2023</p>


                    </div>
                </div>

            </div>

            <div>
                <div className="w-full flex p-5 text-xl font-normal mt-10"
                    style={{
                        borderRadius: "5px",
                        border: "0.5px solid #8F8F8F",
                        background: "#FFF",
                        boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)"
                    }}
                >
                    <p className="w-[50%] border-e-2">1</p>
                    <p className="w-[100%] text-center border-e-2">Harsh Kadyan </p>
                    <p className="w-[100%] text-center border-e-2">Product Lab</p>
                    <p className="w-[100%] text-center border-e-2">Week 4</p>
                    <p className="w-[100%] text-center">12 Apr 2023</p>


                </div>

                <div className="flex justify-end">
                    <div className=" flex p-5 text-xl font-normal mt-5 w-[67%]"
                        style={{
                            borderRadius: "5px",
                            border: "0.5px solid #8F8F8F",
                            background: "#F0F7FF",
                            boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)"
                        }}
                    >

                        <p className="w-[100%] text-center border-e-2">Product Lab</p>
                        <p className="w-[100%] text-center border-e-2">Week 4</p>
                        <p className="w-[100%] text-center">12 Apr 2023</p>


                    </div>
                </div>


            </div>
            
            <div>
                <div className="w-full flex p-5 text-xl font-normal mt-10"
                    style={{
                        borderRadius: "5px",
                        border: "0.5px solid #8F8F8F",
                        background: "#FFF",
                        boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)"
                    }}
                >
                    <p className="w-[50%] border-e-2">1</p>
                    <p className="w-[100%] text-center border-e-2">Harsh Kadyan </p>
                    <p className="w-[100%] text-center border-e-2">Product Lab</p>
                    <p className="w-[100%] text-center border-e-2">Week 4</p>
                    <p className="w-[100%] text-center">12 Apr 2023</p>


                </div>

                <div className="flex justify-end">
                    <div className=" flex p-5 text-xl font-normal mt-5 w-[67%]"
                        style={{
                            borderRadius: "5px",
                            border: "0.5px solid #8F8F8F",
                            background: "#F0F7FF",
                            boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)"
                        }}
                    >

                        <p className="w-[100%] text-center border-e-2">Product Lab</p>
                        <p className="w-[100%] text-center border-e-2">Week 4</p>
                        <p className="w-[100%] text-center">12 Apr 2023</p>


                    </div>
                </div>


            </div>





        </>

    );
};

export default MyLabs;

